<ng-container>
  <c-container [fluid]="true">
    <button
      toggle="visible"
      cHeaderToggler
      [cSidebarToggle]="sidebarId"
      class="ps-1"
    >
      <svg cIcon
        name="cilMenu"
        size="lg"
      ></svg>
    </button>
    <c-header-nav class="d-none d-lg-flex me-auto">
    </c-header-nav>
    <!-- Bandes rouges de CRC, juste avant le thème et le menu utilisateur -->
    <div class="crc-header-bands d-none d-lg-block" aria-hidden="true"></div>
    <c-header-nav class="mx-0">
      <app-theme-switcher class=""></app-theme-switcher>
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav>
  </c-container>

</ng-container>
<ng-template #userDropdown>
  <c-dropdown *ngIf="auth.user$ | async as user" alignment="end" variant="nav-item">

    <a href
       cDropdownToggle
       class="py-0"
    >

      <c-avatar
        shape="rounded-1"
        size="md"
      >
      </c-avatar>
      {{ user.name }}
    </a>
    <ul cDropdownMenu class="pr-5 w-auto">
      <li>
        <a [routerLink]="[]" (click)="logout()"  cDropdownItem>
          Déconnexion
        </a>
      </li>
    </ul>
  </c-dropdown>
</ng-template>
